<template>
  <div class="shop-conditions-conditions-input">
    <div>
      <label class="shop-conditions-conditions-input__label">{{ $t('availableIf') }}:</label>
      <div class="shop-conditions-conditions-input__items">
        <Tree
          v-for="(item, index) in item.categories"
          v-model="value.if"
          :key="'if' + index"
          :item="item"
          class="shop-conditions-conditions-input__item"
        />
      </div>
    </div>
    <div>
      <label class="shop-conditions-conditions-input__label">{{ $t('availableIfNot') }}:</label>
      <div class="shop-conditions-conditions-input__items">
        <Tree
          v-for="(item, index) in item.categories"
          v-model="value.ifnot"
          :key="'ifnot' + index"
          :item="item"
          class="shop-conditions-conditions-input__item"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Tree from './Tree'

export default {
  props: {
    value: Object,
  },
  computed: {
    ...mapState('Shop', ['item']),
  },
  components: {
    Tree,
  },
}
</script>

<style lang="scss">
.shop-conditions-conditions-input {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;

  & > div {
    flex: 1;
  }

  &__label {
    display: block;
    margin-bottom: 0.5rem;
  }

  &__items {
    max-height: calc(100vh - 380px);
    overflow-y: auto;
    border-radius: var(--border-radius);
  }
}
</style>
